<template>
  <div class="background">
    <svg class="title-text" viewBox="0 0 162.5 24">
      <text class="title" x="81.25" y="23" font-size="25" text-anchor="middle">
        Bolus Marker
      </text>
    </svg>
    <button class="bolus-button" @click="buttonClick"></button>
  </div>
</template>

<script>
export default {
  name: 'BolusButton',
  methods: {
    buttonClick() {
      this.$emit('add-bolus-marker')
    }
  }
}
</script>

<style scoped>
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.background {
  display: flex;
  flex-direction: column;
}
.title-text {
  height: 25%;
  fill: #00413b;
}
.bolus-button {
  height: 75%;
  background-image: url('../assets/bolus-button.svg');
  background-color: white;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 65%;
  border: none;
}
button:focus {
  outline: none;
}
</style>
